import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Downloads from './pages/Downloads';
import Login from './components/Login';
import ConsultaGlobal from './components/ConsultaGlobal';
import AvisoAtualizacao from './components/AvisoAtualizacao';
import { authService } from './services/api';
import { usuarioPodeAcessarConsulta } from './utils/loginAccess';
import './styles/App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await authService.checkAuth();
      if (response.autenticado && usuarioPodeAcessarConsulta(response.usuario)) {
        setIsAuthenticated(true);
        setUserData(response.usuario);
      } else if (response.autenticado) {
        await authService.logout();
        setIsAuthenticated(false);
        setUserData(null);
      }
    } catch (error) {
      console.error('Erro ao verificar autenticação:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLoginSuccess = (user) => {
    if (!usuarioPodeAcessarConsulta(user)) return;
    setIsAuthenticated(true);
    setUserData(user);
  };

  // /downloads é público e fica ANTES do gate de autenticação: quem ainda não
  // tem o app instalado precisa poder baixá-lo sem ter onde fazer login. Também
  // é avaliado antes do estado `loading`, para a página não piscar um spinner
  // enquanto o checkAuth (irrelevante aqui) resolve.
  if (window.location.pathname.replace(/\/+$/, '') === '/downloads') {
    return (
      <div className="App">
        <Routes>
          <Route path="/downloads" element={<Downloads />} />
        </Routes>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="app-loading">
        <i className="fas fa-spinner fa-spin"></i>
        <p>Carregando...</p>
      </div>
    );
  }

  return (
    <div className="App">
      {!isAuthenticated ? (
        <Login onLoginSuccess={handleLoginSuccess} />
      ) : (
        <ConsultaGlobal userData={userData} />
      )}
      {/* Só renderiza algo na versão desktop e quando há atualização pendente.
          Fica fora do bloco autenticado de propósito: uma correção crítica deve
          poder chegar mesmo em máquina parada na tela de login. */}
      <AvisoAtualizacao />
    </div>
  );
}

export default App;
